import React, { Component, Suspense, lazy } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { Security, LoginCallback } from "@okta/okta-react";
import AppRouter from "./appRouter";
import LoginErrorCustom from "./components/public/login-error";
import oktaConfig from "./config/oktaConfig";
import { createCloudCmsApiPageContentUrl } from './config/clientConfig';
import axios from "axios";

const Header = lazy(() => import("./components/header"));
const Footer = lazy(() => import("./components/public/footer"));
const Home = lazy(() => import("./components/public/home"));
const ContactUs = lazy(() => import("./components/public/contact-us"));
const ForgotPassword = lazy(() =>
  import("./components/public/reset-password")
);
const ResetPassword = lazy(() => import("./components/public/reset-password"));
const UserRegistration = lazy(() => import("./components/public/user/registration/registration"));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageContent:[]
    };
    this.onAuthRequired = this.onAuthRequired.bind(this);
  }

  onAuthRequired() {
    this.props.history.push("/");
  }

  componentDidMount() {
    axios.get(createCloudCmsApiPageContentUrl())
      .then((res) => {
        this.setState({
          pageContent: res.data
        })
      })
  }

  render() {
    const { pageContent } = {...this.state};

    return (
      <Security {...oktaConfig.oidc} onAuthRequired={this.onAuthRequired}>
        <div className="App">
          <Suspense fallback={<div />}>
            <Header pageContent={pageContent}/>
            <Switch>
              <Route path="/" exact={true}  
                render={() => (
                    <Home pageContent={pageContent} />
                  )}
              />
              <Route
                path="/authorization-code/callback"
                exact={true}
                render={() => (
                  <LoginCallback errorComponent={LoginErrorCustom} />
                )}
              />
              <Route
                path="/public/contact-us"
                exact={true}
                component={ContactUs}
              />
              <Route
                path="/public/forgot-password"
                exact={true}
                component={ForgotPassword}
              />
              <Route
                path="/public/reset-password"
                exact={true}
                component={ResetPassword}
              />
              <Route
                path="/public/user/registration"
                exact={true}
                component={UserRegistration}
              />
              {/* Secured routes */}
              <AppRouter />
            </Switch>
            <Footer pageContent={pageContent}/>
          </Suspense>
        </div>
      </Security>
    );
  }
}

export default withRouter(App);
